import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';

import { AdminSection } from '../../../../models/app.models';

import { LocationService } from '../../../../services/location.service';
import { CommunityPostService } from '../../../../services/community-post.service';
import { StaffMemberService } from '../../../../services/staff-member.service';

@Component({
  selector: 'app-admin-overview',
  standalone: true,
  templateUrl: './admin-overview.component.html',
  styleUrls: ['./admin-overview.component.css',  '../../admin-section.shared.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminOverviewComponent
  implements OnInit {

  @Output()
  sectionSelected =
    new EventEmitter<AdminSection>();

  locationsCount = 0;
  communityPostsCount = 0;
  staffMembersCount = 0;

  locationsLoading = true;
  communityLoading = true;
  staffLoading = true;

  constructor(
    private readonly locationService:
      LocationService,
    private readonly communityPostService:
      CommunityPostService,
    private readonly staffMemberService:
      StaffMemberService,
    private readonly changeDetector:
      ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadCounts();
  }

  selectSection(
    section: AdminSection
  ): void {
    this.sectionSelected.emit(section);
  }

  private loadCounts(): void {
    this.locationService
      .getAdminLocations()
      .subscribe({
        next: locations => {
          this.locationsCount =
            locations.length;

          this.locationsLoading = false;

          this.changeDetector.markForCheck();
        },

        error: () => {
          this.locationsLoading = false;

          this.changeDetector.markForCheck();
        }
      });

    this.communityPostService
      .getAdminPosts()
      .subscribe({
        next: posts => {
          this.communityPostsCount =
            posts.length;

          this.communityLoading = false;

          this.changeDetector.markForCheck();
        },

        error: () => {
          this.communityLoading = false;

          this.changeDetector.markForCheck();
        }
      });

    this.staffMemberService
      .getAdminStaffMembers()
      .subscribe({
        next: members => {
          this.staffMembersCount =
            members.length;

          this.staffLoading = false;

          this.changeDetector.markForCheck();
        },

        error: () => {
          this.staffLoading = false;

          this.changeDetector.markForCheck();
        }
      });
  }
}